// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s7-0";
export var leftAlign = "_s7-4";
export var listItem = "_s7-2";
export var listItemWrapper = "_s7-1";
export var operationText = "_s7-3";